import moment from "moment"
import _startsWith from "lodash/startsWith"
import _transform from "lodash/transform"
import _replace from "lodash/replace"

import "moment/locale/pt-br"

import { removeMaskCEP, removeMaskTel } from "services/utils/mask"

moment.locale("pt-br")

const defaultResponsibleData = {
  nome_divergente: "nao",
  tipos_pessoa: ["1"],
  tipo_documento_pessoa: ["RG", "CNH"]
}

const formatDate = (value) => {
  const date = moment(value, "DD/MM/YYYY", true)
  return date.format("YYYY-MM-DD")
}

const formatAccounts = (account) => {
  return _transform(
    account,
    (acc, value, key) => {
      if (_startsWith(key, "issueDate")) {
        const suffix = _replace(key, "issueDate", "")
        const billKey = `bill${suffix}`

        if (account[billKey]) {
          const formatted = formatDate(value)
          acc[formatted] = account[billKey]
        }
      }
    },
    {}
  )
}

export const normalizePayload = (payload) => {
  const account = formatAccounts(payload)
  const { isSameDataResponsible } = payload

  const responsibleMain = {
    ...defaultResponsibleData,
    nome: payload.name,
    cpf: payload.cpf,
    data_nascimento: formatDate(payload.birthDate),
    arquivo_documento_pessoa: payload.fileRG,
    email1: payload.email,
    celular1: removeMaskTel(payload.phoneNumber)
  }

  const accountHolder = {
    ...defaultResponsibleData,
    nome: payload.holderName,
    cpf: payload.holderCpf,
    data_nascimento: formatDate(payload.holderBirthDate),
    email1: payload.holderEmail,
    celular1: removeMaskTel(payload.holderPhoneNumber)
  }

  const responsible = isSameDataResponsible
    ? [responsibleMain]
    : [responsibleMain, accountHolder]

  return {
    empresa: {
      cnpj: payload.customer.documentNumber,
      razao_social: payload.customer.name
    },
    responsaveis: responsible,
    unidades_consumidoras: [
      {
        numero: payload.customerNumber,
        distribuidora_id: payload.energyDistributor,
        fatura_divergente: "nao",
        tipo_uc: payload.accountHolder,
        cep: removeMaskCEP(payload.cep),
        logradouro: payload.address,
        numero_endereco: payload.number,
        bairro: payload.neighborhood,
        complemento: payload.complement,
        estado: payload.state,
        cidade: payload.city,
        historico_consumo: account,
        arquivo_fatura: payload.fileEnergy
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/scenes/SharedEnergy/utils.js